module.exports = __webpack_public_path__ + "static/Donations-912fbf9eecd5112a353e89f0aa85283b.png";